import React, { Component, Fragment } from "react";
// import AppChat from "app/views/app/chat/AppChat";
// import AppAccordion from "app/views/ui-kits/accordions/AppAccordion";
// import Googlemap from '../../Components/GoogleMap/GoogleMap'
import "leaflet/dist/leaflet.css";
import localStorageService from "app/services/localStorageService";
import toastr from "toastr";

import {
  Circle,
  CircleMarker,
  Map,
  Polygon,
  Polyline,
  Popup,
  Rectangle,
  TileLayer,
  Marker,
} from "react-leaflet";
import { Link } from "react-router-dom";
import { projectIcon } from "app/_helpers/mapHelper";

const L = require("leaflet");

// const myIcon = L.icon({
//     iconUrl: '/assets/images/customMarker.png',
//     iconSize: [20, 70],
//     iconAnchor: [10, 70],
//     // popupAnchor: null,
//     // shadowUrl: null,
//     // shadowSize: null,
//     // shadowAnchor: null
// });

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLocation: { lat: 51.5, lng: -0.06 },
      zoom: 2,
      auth_user: localStorageService.getItem("auth_user"),
    };
    const token = localStorage.getItem("jwt_token");
    if (!this.state.auth_user) {
      if (token) {
        toastr.error("unauthorized");
      }
      localStorage.removeItem("jwt_token");
      localStorage.removeItem("userDashBoardData");
      localStorage.removeItem("aryauserType");

      this.props.history.push({
        pathname: "/session/signin",
      });
    }
  }

  componentWillMount() {
    document.body.classList.add("noPad");
  }

  componentWillUnmount() {
    document.body.classList.remove("noPad");
  }

  onClickProject = (projectId) => {
    this.props.history.push("/project/" + projectId + "/home");
  };

  onClickMarkerSetProjectCoordinate = (currentLocation) => {
    const map = this.state.map.leafletElement; //get native Map instance

    // set position
    map.fitBounds(currentLocation);
  };

  handleZoomstart = () => {
    // TODO handle move event
    const map = this.state.map.leafletElement; //get native Map instance

    this.setState({
      zoom: map.getZoom(),
    });
  };

  render() {
    const { currentLocation, zoom, markers, fitBounds } = this.state;

    return (
      <React.Fragment>
        <div>
          <Map
            ref={(ref) => {
              this.state.map = ref;
            }}
            center={currentLocation}
            zoom={zoom}
            className="cusReaflet-map"
            onZoomEnd={this.handleZoomstart}
          >
            <TileLayer
              url="https://api.mapbox.com/styles/v1/planemad/ckf4xcet7231819mm2e8njlca/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYW1pdGNvZGVmaXJlIiwiYSI6ImNrbmp3a21keTA1YzAydW10Zjlxd3B5bnQifQ.Dqm42LRHmL9Hz6PbvPUGiQ"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />

            {this.state.auth_user &&
              Array.isArray(this.state.auth_user.UserProject) &&
              this.state.auth_user.UserProject.map((userProject) => {
                let polygon = [];

                if (userProject && Array.isArray(userProject.project_locations)) {
                  userProject.project_locations.forEach((element) => {
                    polygon.push([element.lattitude, element.longitude]);
                  });
                }

                return (
                  <Fragment>
                    {Array.isArray(polygon) && polygon.length > 0 && (
                      <Fragment>
                        <Polygon
                          positions={polygon}
                          color="#00b5ef"
                          onMouseOver={(e) => {
                            e.target.openPopup();
                          }}
                          onMouseOut={(e) => {
                            e.target.closePopup();
                          }}
                          onClick={(e) => this.onClickProject(userProject.id)}
                        >
                          <Popup>
                            <Link to={"project/1/home"}>{userProject.name}</Link>
                          </Popup>
                        </Polygon>

                        {zoom < 10 && (
                          <Fragment>
                            <Marker
                              position={polygon[0]}
                              icon={projectIcon}
                              onClick={(e) =>
                                this.onClickMarkerSetProjectCoordinate(polygon)
                              }
                              onMouseOver={(e) => {
                                e.target.openPopup();
                              }}
                              onMouseOut={(e) => {
                                e.target.closePopup();
                              }}
                            >
                              <Popup>{userProject.name}</Popup>
                            </Marker>
                          </Fragment>
                        )}
                      </Fragment>
                    )}
                  </Fragment>
                );
              })}
          </Map>
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
